import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import { Alert, Box, Button, Container, Grid, Typography } from "@mui/material";
import CheckIcon from '@mui/icons-material/Check';

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { FormTextField } from "components/FormInputs";

export default function SignupPage() {

  const navigate = useNavigate();

  const [isPwdNotMatch, setIsPwdNotMatch] = useState(false);
  const [isUserIdDuplication, setIsUserIdDuplication] = useState(false);
  const [isSignupSuccessed, setIsSignupSuccessed] = useState(false);

  const schema = yup.object().shape({
    userName: yup.string().required("이름을 입력해주세요."),
    userId: yup.string().required("ID를 입력해주세요."),
    pwd: yup.string().required("비밀번호를 입력해주세요."),
    repwd: yup.string().required("비밀번호 확인를 입력해주세요.")
  });

  const {
    control,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  });

  // 회원가입
  const onSignup = (formData) => {
    if (formData.pwd !== formData.repwd) {
      setIsPwdNotMatch(true);
      return;
    }

    setIsPwdNotMatch(false);

    axios.post("/api/user/signup", formData)
    .then(res => {
      if (res.data === "success") {
        setIsSignupSuccessed(true);
      } else if (res.data === "user_id_exists") {
        setIsUserIdDuplication(true);
      } else {
        alert("회원가입에 실패하였습니다.");
      }
    })
    .catch(err => {
      alert("회원가입에 실패하였습니다.");
    });
  };

  return (
    <Container maxWidth="xs" sx={{marginTop: "75px", marginBottom: "75px"}}>
      {!isSignupSuccessed ?
        <form onSubmit={handleSubmit(onSignup)}>
          <Grid container flexDirection="column" gap="16px">
            <Typography sx={{
              fontFamily: "NanumSquareExtraBold",
              fontSize: "1.5rem",
              textAlign: "center"
            }}>🔒&nbsp;회원가입</Typography>

            {isPwdNotMatch &&
              <Alert severity="error" onClose={() => setIsPwdNotMatch(false)}>비밀번호가 일치하지 않습니다.</Alert>
            }

            {isUserIdDuplication &&
              <Alert severity="error" onClose={() => setIsUserIdDuplication(false)}>이미 가입된 ID입니다.</Alert>
            }

            <FormTextField
              name="userName"
              label="이름"
              control={control}
              error={errors.userName}
            />

            <FormTextField
              name="userId"
              label="ID"
              control={control}
              error={errors.userId}
            />

            <FormTextField
              name="pwd"
              label="Password"
              control={control}
              error={errors.pwd}
              type="password"
            />

            <FormTextField
              name="repwd"
              label="Password 확인"
              control={control}
              error={errors.repwd}
              type="password"
            />

            <Button variant="contained" onClick={handleSubmit(onSignup)}>회원가입</Button>
          </Grid>
        </form>
        :
        <Grid container flexDirection="column" alignItems="center" sx={{color: "gray"}}>
          <CheckIcon sx={{fontSize: "3rem", marginBottom: "4px"}}/>
          <Typography fontSize={"1.25rem"} marginBottom="32px">회원가입이 완료되었습니다.</Typography>
          <Button variant="outlined" onClick={() => navigate("/login")}>로그인</Button>   
        </Grid>
      }
    </Container>
  );
}